import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// One MSAL instance for the whole app. index.js gives it to MsalProvider and
// utils/apiFetch.js uses it to get the access token for Feelim's APIs.
export const msalInstance = new PublicClientApplication(msalConfig);
